import Question from '~/components/forms/Question';
import { getHiddenQuestionIds } from '~/lib/FormHelpers';

const Section = ({ section, questions, formData, setFormData, isVisible }) => {
    if (questions.length === 0) {
        return null;
    }

    // Hide any questions after scheduling if we haven't yet completed scheduling
    const hideQuestions = getHiddenQuestionIds(questions, formData);

    return (
        <div className="mb-4">
            {questions.map(question => (
                <div key={question.id}>
                    {hideQuestions.indexOf(question.id) < 0 && (
                        <div key={question.id} className="mb-4">
                            <Question
                                isReadOnly={false}
                                isVisible={isVisible}
                                question={question}
                                value={formData[question.id]}
                                setValue={value =>
                                    setFormData(question.id, value)
                                }
                                id={`answers.${question.id}`}
                            />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Section;
